import isString from 'lodash/isString'
import { useCallback, useContext, useEffect, useState } from 'react'

import { MetadataContext } from '@Globals/Metadata'

interface SavedCheckoutDataProps {
  byJunoData?: {
    day: string
    gender: string
    invoiceType: string
    month: string
    year: string
  }
  currentStep?: string | null
  externalCustomerId?: string | null
  isOptInToNewsletter?: string | null
  quoteId?: string | null
  savedPaymentInputData: null | unknown
  selectedDroppoint?: string
  storeId: string
  timeStamp: number
}

const CHECKOUT_LOCALSTORAGE = 'cofDataSavedV2'
export const useSavedCheckoutLocalData = () => {
  const [checkoutLocal, setCheckoutLocal] = useState<null | SavedCheckoutDataProps>(null)
  const { store: { id: storeID } } = useContext(MetadataContext)

  const getLocalstorage: () => SavedCheckoutDataProps | null = () => {
    const data = localStorage.getItem(CHECKOUT_LOCALSTORAGE)
    const res: null | SavedCheckoutDataProps = isString(data) ? JSON.parse(data) : null
    if (!!res && !!res.currentStep) {
      switch (`${res.currentStep}`) {
        case '1':
          res.currentStep = 'address'
          break
        case '2':
          res.currentStep = 'shipping'
          break
        default:
          break
      }
    }
    return res
  }

  const getSavedCheckoutData = useCallback(() => {
    if (typeof localStorage !== 'undefined') {
      return getLocalstorage()
    }
    return null
  }, [])

  const saveCheckoutLocal = useCallback((data: Partial<SavedCheckoutDataProps>) => {
    if (typeof localStorage !== 'undefined') {
      const defaultData = {
        storeId: storeID,
        timeStamp: Date.now(),
      }
      const oldData = getSavedCheckoutData() || {}
      const newData = {
        ...oldData,
        ...defaultData,
        ...data,
      }
      setCheckoutLocal(newData as SavedCheckoutDataProps)
      localStorage.setItem(CHECKOUT_LOCALSTORAGE, JSON.stringify(newData))
    }
  }, [getSavedCheckoutData, storeID])

  useEffect(() => {
    setCheckoutLocal(getSavedCheckoutData())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { saveCheckoutLocal, checkoutLocal, getLocalstorage }
}
